<p-menubar [autoDisplay]="false" [breakpoint]="'0px'" [model]="mainMenu" styleClass="raised-navbar center-menu" [style]="{ height: '80px' }">
  <!-- Left: Logo -->
  <ng-template pTemplate="start">
    <img src="../../../assets/images/upspl_log.png" alt="UPSPL Logo" class="logo"  />
  </ng-template>

  <!-- Right: Notifications + Profile -->
  <ng-template pTemplate="end">
    <div class="menu-end">
      <button *ngIf="canUseTicketing" type="button" class="support-btn" (click)="openTicketCenter()" aria-label="Support tickets" pTooltip="Support Tickets">
        <i class="pi pi-question-circle"></i>
      </button>
      <!-- Bell with overlay badge -->
      <span class="p-overlay-badge bell-btn" role="button" tabindex="0" (click)="onNotifications()">
        <i class="pi pi-bell"></i>
        <p-badge [value]="unreadCount" severity="danger"></p-badge>
      </span>

      <!-- Avatar -->
      <a (click)="avatarMenu.toggle($event)" class="avatar-link" aria-label="Profile menu">
        <ng-container *ngIf="getUserProfileImage(); else defaultProfile">
          <img [src]="getUserProfileImage()" alt="Profile" class="avatar-img" />
        </ng-container>
        <ng-template #defaultProfile>
          <img src="assets/icons/admin.svg" alt="Profile" class="avatar-img" />
        </ng-template>
      </a>
      <p-menu #avatarMenu [popup]="true" [model]="profileMenuItems" styleClass="profile-menu" appendTo="body"></p-menu>
     <!-- NEW Custom Hamburger -->
        <button class="mobile-toggle" (click)="toggleMobileMenu()">
          <i class="pi pi-bars"></i>
        </button>
    </div>
  </ng-template>
</p-menubar>

<!-- MOBILE MENU BELOW NAVBAR -->
<div class="mobile-menu" *ngIf="isMobileMenuOpen">

  <div *ngFor="let item of mainMenu">

    <!-- NORMAL MENU -->
    <a
      *ngIf="!item.items"
      [routerLink]="item.routerLink"
      class="mobile-item"
      (click)="toggleMobileMenu()">
      {{ item.label }}
    </a>

    <!-- MENU WITH SUB ITEMS -->
    <div *ngIf="item.items">

      <!-- Parent -->
      <div 
        class="mobile-item mobile-parent"
        (click)="toggleSubMenu(item.label!)">

        {{ item.label }}
        <i 
          class="pi"
          [ngClass]="expandedMenus[item.label!] ? 'pi-chevron-up' : 'pi-chevron-down'">
        </i>

      </div>

      <!-- Children -->
      <div *ngIf="expandedMenus[item.label!]">

        <a
          *ngFor="let sub of item.items"
          [routerLink]="sub.routerLink"
          class="mobile-item mobile-sub"
          (click)="toggleMobileMenu()">
          {{ sub.label }}
        </a>

      </div>

    </div>

  </div>

</div>

<ft-ticket-center *ngIf="canUseTicketing" [(visible)]="showTicketCenter"></ft-ticket-center>
